var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.nav == 'options')?_c('div',[_c('OptionsPage',{attrs:{"changeNav":_vm.changeNav,"imageData":_vm.imageData}})],1):_c('div',[_c('Home',{attrs:{"setImageData":_vm.setImageData,"changeNav":_vm.changeNav}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }